import React, { useEffect, useState } from 'react'
import {
  matchPath,
  Redirect,
  Route,
  RouteProps,
  useLocation,
} from 'react-router-dom'

import { getFluxoFlowBySlug } from '../../services/form-flow'
import getCookie from '../../utils/getCookies'
import BlankLayout from '../Layouts/BlankLayout'

interface Props extends RouteProps {
  layout: React.ComponentType<any>
  component: React.ComponentType<any>
  // eslint-disable-next-line react/require-default-props
  isAuth?: boolean
  // Libera a rota sem token quando o Flow do Formflow (identificado pelo
  // :slug da própria rota) tiver permite_acesso_sem_login=True.
  // eslint-disable-next-line react/require-default-props
  allowSemLoginFlow?: boolean
}

const RouteLayout = (props: Props): JSX.Element | null => {
  const token: string | null = getCookie('gov_access_token_sso')
  const { pathname, state } = useLocation()

  const {
    layout: Layout,
    component: Component,
    path,
    isAuth,
    allowSemLoginFlow,
    exact,
  } = props

  const attendanceOnlineChatUrl = '/workspace/atendimento_online/'
  const doesNotPathNameHasAttendanceOnlineChatUrl = !pathname.startsWith(
    attendanceOnlineChatUrl,
  )

  const requiresAuthCheck = Boolean(
    isAuth && !token && doesNotPathNameHasAttendanceOnlineChatUrl,
  )

  const match = matchPath<{ slug?: string }>(pathname, {
    path: path as string,
    exact,
  })
  const flowSlug = match?.params?.slug

  const checksSemLoginFlow = Boolean(
    requiresAuthCheck && allowSemLoginFlow && flowSlug,
  )

  const [checkingSemLogin, setCheckingSemLogin] = useState(checksSemLoginFlow)
  const [semLoginAllowed, setSemLoginAllowed] = useState(false)

  useEffect(() => {
    if (!checksSemLoginFlow || !flowSlug) return undefined

    let cancelled = false
    setCheckingSemLogin(true)

    getFluxoFlowBySlug(flowSlug)
      .then(({ data }) => {
        if (cancelled) return
        const flow = data?.results?.[0] ?? null
        setSemLoginAllowed(Boolean(flow?.permite_acesso_sem_login))
      })
      .catch(() => {
        if (!cancelled) setSemLoginAllowed(false)
      })
      .finally(() => {
        if (!cancelled) setCheckingSemLogin(false)
      })

    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flowSlug, checksSemLoginFlow])

  if (checksSemLoginFlow) {
    if (checkingSemLogin) return null
    if (!semLoginAllowed) return <Redirect to="/" />
  } else if (requiresAuthCheck) {
    return <Redirect to="/" />
  }

  const CurrentLayoutPage = state === 'mobile' ? BlankLayout : Layout

  return (
    <Route
      path={path}
      render={(matchProps) => (
        <CurrentLayoutPage>
          <Component {...matchProps} />
        </CurrentLayoutPage>
      )}
    />
  )
}

export default RouteLayout
